module.exports = __webpack_public_path__ + "media/images/top/icon/gray/ico_angle-7d25ee938127476b8783c235ff409784.svg";